import React, { useEffect } from 'react'
import { AdvertorialTemplate, SEO } from '@/components'
import { buildStaticPaths, buildStaticProps } from '../../../ssg/advertorial'
import Head from 'next/head'
import isOrganicPageView from '@/utils/vertical-helpers/is-organic-page-view'
import { writeOriginToSession } from '@/utils/landing-page/write-origin-to-session'

function AutoInsuranceAdvertorial(props: any) {
  const phoneNumber = '1.844.673.1431'
  const { seoTitle, seoDescription, ...templateProps } = props
  const isGoogleAdvertorial = templateProps.slug.includes('advantage-compare')


  return (
    <>
      {isGoogleAdvertorial && (
        <Head>
          <script
            async
            src="https://www.googletagmanager.com/gtag/js?id=AW-705777187"
          ></script>
          <script
            async
            id="segment"
            dangerouslySetInnerHTML={{
              __html: `
              window.dataLayer = window.dataLayer || [];
              function gtag(){dataLayer.push(arguments);}
              gtag('js', new Date());
              gtag('config', 'AW-705777187');
            `,
            }}
          />
          <script
            async
            id="segment"
            dangerouslySetInnerHTML={{
              __html: `
              gtag('config', 'AW-705777187/wE0kCNqy_vQYEKOcxdAC', {
                'phone_conversion_number': '18446731431'
              });
            `,
            }}
          />
        </Head>
      )}
      <SEO title={seoTitle || props.title} description={seoDescription} />
      <AdvertorialTemplate {...templateProps} phoneNumber={phoneNumber}/>
    </>
  )
}

export async function getStaticPaths() {
  return buildStaticPaths('health-insurance')
}

export async function getStaticProps({
  params,
}: {
  params: {
    slug: string
  }
}) {
  const { props } = await buildStaticProps(params)
  const isGoogleAdvertorial =
    [
      'advantage-sem',
      'advantage',
      'call-today',
      'supplement',
      'advantage-compare',
    ].some((keyword) => params.slug.includes(keyword)) ||
    !isOrganicPageView('google')
  return { props: { ...props, isGoogleAdvertorial } }
}

export default AutoInsuranceAdvertorial
